var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.85,
    height: 26.85,
    viewBox: "0 0 26.85 26.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4095",
    "data-name": "Rectangle 4095",
    width: 26.85,
    height: 26.85,
    fill: "#00bc4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10002",
    "data-name": "Group 10002",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10001",
    "data-name": "Group 10001",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44321",
    "data-name": "Path 44321",
    d: "M0,13.4A13.425,13.425,0,1,1,13.388,26.85,13.464,13.464,0,0,1,0,13.4M13.415,25.261A11.837,11.837,0,1,0,1.588,13.415,11.875,11.875,0,0,0,13.415,25.261",
    transform: "translate(0 0)",
    fill: "#00bc4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44322",
    "data-name": "Path 44322",
    d: "M21.132,28.265a2.186,2.186,0,0,1,.212-.3q3.281-3.288,6.565-6.573a.892.892,0,0,1,.834-.34.791.791,0,0,1,.482,1.249,2.256,2.256,0,0,1-.239.261l-7.2,7.2c-.524.523-.906.521-1.434-.007q-1.956-1.956-3.914-3.91a.818.818,0,0,1-.25-.859.753.753,0,0,1,.638-.546.847.847,0,0,1,.762.305q1.619,1.623,3.242,3.243c.075.075.153.146.3.283",
    transform: "translate(-9.343 -12.164)",
    fill: "#00bc4b",
    stroke: "#00bc4b",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.3082d52509156aaf8a443786627d8001.svg";
export { ForwardRef as ReactComponent };